export const sources={webp:"__VITE_ASSET__CKbh5mKn__ 72w"};export const img={src:"__VITE_ASSET__D_LO5feX__",w:72,h:72};export default{sources:sources,img:img};